import { store } from '@/state';

const MIN_HEIGHT = 80;
const MAX_HEIGHT = 500;

/**
 * Initialize the live feed resize handle
 */
export function initLiveFeedResize(): void {
  const handle = document.getElementById('live-feed-resize-handle');
  const missionControl = document.getElementById('mission-control');
  if (!handle || !missionControl) return;

  let startY = 0;
  let startHeight = 0;
  let isDragging = false;

  function onMouseDown(e: MouseEvent): void {
    e.preventDefault();
    isDragging = true;
    startY = e.clientY;
    const liveFeedHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--live-feed-height')
    );
    startHeight = liveFeedHeight;
    handle!.classList.add('active');
    document.body.style.cursor = 'ns-resize';
    document.body.style.userSelect = 'none';
  }

  function onMouseMove(e: MouseEvent): void {
    if (!isDragging) return;
    const delta = startY - e.clientY;
    const newHeight = Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, startHeight + delta));
    document.documentElement.style.setProperty('--live-feed-height', `${newHeight}px`);

    // Resize globe to fit
    const globe = store.get('globe');
    if (globe) {
      const container = document.querySelector('.globe-container') as HTMLElement;
      if (container) {
        globe.width(container.clientWidth);
        globe.height(container.clientHeight);
      }
    }
  }

  function onMouseUp(): void {
    if (!isDragging) return;
    isDragging = false;
    handle!.classList.remove('active');
    document.body.style.cursor = '';
    document.body.style.userSelect = '';
  }

  handle.addEventListener('mousedown', onMouseDown);
  document.addEventListener('mousemove', onMouseMove);
  document.addEventListener('mouseup', onMouseUp);
}
